import { ColumnSort } from '@components/data-grid';
import { sortByObjectKey } from '@utils/collections';
import { compareStrings } from '@utils/sorting';

type SortableTemplate = { title: string | null; templateType: string };

export const sortTemplates = <Template extends SortableTemplate>(
  templates: Array<Template>,
  sort: ColumnSort<Template>,
  getTypeLabel: (templateType: string) => string,
): Array<Template> => {
  const isDescending = sort.order === 'descending';

  if (sort.key === 'title') {
    return sortByObjectKey(templates, 'title', isDescending);
  }

  if (sort.key === 'templateType') {
    return [...templates].sort((templateA, templateB) => {
      return compareStrings(
        getTypeLabel(templateA.templateType),
        getTypeLabel(templateB.templateType),
        !isDescending,
      );
    });
  }

  return templates;
};
